import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal-new-billing",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "modal-new-billing-title",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title",
  id: "modal-new-billing-title"
}
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BtnSubmit = _resolveComponent("BtnSubmit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "modal-content",
        onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onKeyboardEvent && _ctx.onKeyboardEvent(...args)))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(this.isEditing() ? 'Edit Billing Account' : 'New Billing Account'), 1),
          _cache[3] || (_cache[3] = _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }, [
            _createElementVNode("span", { "aria-hidden": "true" }, "×")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { for: "modal-new-billing-name" }, "Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "modal-new-billing-name",
                placeholder: "Account name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { for: "modal-new-billing-desc" }, "Description", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                id: "modal-new-billing-desc",
                rows: "3",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event))
              }, null, 512), [
                [_vModelText, _ctx.description]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_BtnSubmit, {
            title: this.isEditing() ? 'Update' : 'Create Account',
            spinner: "",
            ref: "submitButton",
            submitHandler: _ctx.createBilling
          }, null, 8, ["title", "submitHandler"])
        ])
      ], 32)
    ])
  ]))
}